import {defineStore} from 'pinia';
import Network from "~/utils/network";

const urls = {
    getFacebookPixelId: (financer) => `/api/administration/pixel/facebook/${financer}`,
};

export const usePixelStore = defineStore('pixel', {
    state: () => ({
        pixelId: null,
    }),
    actions: {
        fetchFacebookPixelId: async function (financer) {
            try {
                const data = await Network.http(urls.getFacebookPixelId(financer), {
                    method: 'GET',
                });
                this.pixelId = data;
            } catch (err) {
                console.log(err);
                await Promise.reject(err);
            }
        },
    },
    getters: {
        // pixelId(state) {
        //     return state.pixelId;
        // },
    },
});
